import * as types from '../mutation-types'
import * as actionTypes from '../action-types'
import server from '../server'
import moment from 'moment-es6'
import { clearFilters, getAppliedFilters } from '../../HelperMethods'
import store from '../../store'
import axios from 'axios/index'

const defaultState = () => ({
  interactionsList: [],
  originalList: [],
  interactionsListTransition: 'list',
  loading: false,
  currentPage: 0,
  totalElements: 0,
  pageSize: 20,
  totalPages: 0,
  lastPage: false,
  sortBy: 'SORT_DATE:::DESC',
  sortFields: [
    {
      'text': 'surname_asc',
      'value': 'INTERACTION_LAST_NAME:::ASC'
    },
    {
      'text': 'surname_desc',
      'value': 'INTERACTION_LAST_NAME:::DESC'
    },
    {
      'text': 'intervention_date_asc',
      'value': 'SORT_DATE:::ASC'
    },
    {
      'text': 'intervention_date_desc',
      'value': 'SORT_DATE:::DESC'
    }
  ],
  scrollTop: 0,
  // Filters
  startDate: moment().subtract(28, 'days').format('YYYY-MM-DD'),
  endDate: moment().format('YYYY-MM-DD'),
  filterFields: {
    myTutees: {
      header: 'student.filters.headers.tutees',
      isNotTutor: true,
      values: {
        MY_TUTEES: {
          value: false,
          text: 'student.filters.values.my_tutees'
        }
      }
    },
    interactionTypes: {
      header: 'interactions.filters.headers.interaction_type',
      values: {
        INTERVENTION: {
          value: false,
          text: 'interactions.filters.values.interventions',
          icon: 'mdi-account-multiple'
        },
        ALERT: {
          value: false,
          text: 'interactions.filters.values.alerts',
          icon: 'alarm'
        },
        EXEMPTION: {
          value: false,
          text: 'interactions.filters.values.exemptions',
          icon: 'timelapse'
        }
      }
    }
  },
  functions: {
    interactions: 'INTERACT'
  },
  options: {
    enable: {
      alertFilter: 'ENBALTFIL'
    }
  }
})

const mutations = {
  [types.SET_INTERACTIONS_LIST] (state, interactionsList) {
    state.interactionsList = interactionsList
  },
  [types.INTERACTIONS_LIST_LOADING] (state) {
    state.loading = true
  },
  [types.INTERACTIONS_LIST_NOT_LOADING] (state) {
    state.loading = false
  },
  [types.SET_INTERACTIONS_LIST_SCROLL_TOP] (state, scrollTop) {
    state.scrollTop = scrollTop
  },
  [types.UPDATE_INTERACTIONS_LIST] (state, data) {
    state.interactionsList.find(interaction => {
      if (interaction.intervention && interaction.intervention.id === data.id) {
        interaction.isHidden = data.isHidden
      }
    })
    if (data.isHidden) {
      state.interactionsList = state.interactionsList.filter(i => !i.isHidden)
      state.totalElements = state.totalElements - 1
    } else {
      state.interactionsList = state.originalList
      state.totalElements = state.totalElements + 1
    }
  },
  [types.SET_INTERACTIONS_LOADED] (state, data) {
    state.interactionsList = data.interactionsList.filter(i => !i.isHidden)
    state.originalList = state.interactionsList
    state.totalElements = data.totalElements
    state.loading = false
    // state.currentPage += 1
    state.lastPage = data.lastPage
    state.totalPages = Math.ceil(data.totalElements / state.pageSize)
  },
  [types.SET_INTERACTIONS_SORTING] (state, sortBy) {
    state.sortBy = sortBy
  },
  [types.HIDE_INTERVENTION_BY_ID] (state, id) {
    changeInterventionVisibility(state.interactionsList.find(interaction => interaction.intervention && interaction.intervention.id === id), true)
  },
  [types.SHOW_INTERVENTION_BY_ID] (state, id) {
    changeInterventionVisibility(state.interactionsList.find(interaction => interaction.intervention && interaction.intervention.id === id), false)
  },
  [types.UPDATED_INTERVENTION] (state, intervention) {
    let index = state.interactionsList.findIndex(elem => elem.intervention.id === intervention.id)
    if (index >= 0) {
      state.interactionsList[index].intervention = intervention
    }
  },
  [types.EMPTY_INTERACTIONS_LIST] (state) {
    state.interactionsList = []
    state.totalElements = 0
    state.loading = false
    state.currentPage = 0
    state.lastPage = false
  },
  [types.SET_INTERACTIONS_TRANSITION] (state, transition) {
    state.interactionsListTransition = transition
  },
  [types.INTERACTIONS_DATE_FILTER_CHANGE] (state, filters) {
    if (filters.startDate) {
      state.startDate = filters.startDate
      state.endDate = filters.endDate
    }
  },
  [types.INTERACTIONS_DATE_AND_FILTER_RESET] (state, filters) {
    let myTutees = state.filterFields.myTutees.values.MY_TUTEES.value
    state.startDate = moment().subtract(28, 'days').format('YYYY-MM-DD')
    state.endDate = moment().format('YYYY-MM-DD')
    state.filterFields = clearFilters(state.filterFields)
    state.filterFields.myTutees.values.MY_TUTEES.value = myTutees
  },
  [types.UPDATE_EXEMPTION_MUTATION] (state, data) {
    const exemption = state.interactionsList.find(interaction => interaction.exemption && interaction.exemption.id === data.id)
    if (exemption) {
      exemption.exemption.startDate = data.startDate
      exemption.exemption.endDate = data.endDate
      exemption.exemption.exemptionReason = data.exemptionReason
    }
  },
  [types.DELETE_EXEMPTION_MUTATION] (state, id) {
    state.interactionsList = state.interactionsList.filter(interaction => !(interaction.exemption && interaction.exemption.id === id))
  },
  [types.TOGGLE_INTERACTIONS_LIST_FILTER] (state, {filterType, filterName, value}) {
    state.filterFields[filterType].values[filterName].value = value !== undefined ? value : !state.filterFields[filterType].values[filterName].value
  },
  [types.SET_INTERACTIONS_PAGE_SIZE] (state, size) {
    state.pageSize = size
  },
  [types.SET_INTERACTIONS_PAGE_NUMBER] (state, number) {
    state.currentPage = number
  },
  [types.REPLACE_INTERACTIONS] (state, content) {
    state.interactionsList = content
  },
  [types.SET_INTERACTIONS_TOTAL_ELEMENTS] (state, number) {
    state.totalElements = number
  },
  [types.CLEAR_INTERACTIONS_LIST_FILTERS] (state) {
    state.filterFields = clearFilters(state.filterFields)
  },
  [types.RESET_INTERACTIONS_MODULE] (state) {
    const initial = defaultState()
    Object.keys(initial).forEach(key => { state[key] = initial[key] })
  },
  [types.SET_IS_TUTOR] (state, isNotTutor) {
    state.filterFields.myTutees.isNotTutor = !isNotTutor
  }
}

let getInteractionsList = function (context, actionData) {
  return server.postReplayable('/core/interaction/filter', {
    pageNumber: context.state.currentPage,
    pageSize: context.state.pageSize,
    ascDesc: context.state.sortBy.split(':::')[1],
    sortBy: context.state.sortBy.split(':::')[0],
    fromDate: context.state.startDate,
    toDate: context.state.endDate,
    ...getAppliedFilters(context.state.filterFields)
  }, actionData)
}
const actions = {
  async [actionTypes.GET_LIST_OF_INTERACTIONS] ({commit, state, rootState}) {
    commit(types.INTERACTIONS_LIST_LOADING)
    const actionData = { action: actionTypes.GET_LIST_OF_INTERACTIONS }
    let intData = {}

    await axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/interaction/filter`,
      method: 'post',
      data: {
        pageNumber: state.currentPage,
        pageSize: state.pageSize,
        ascDesc: state.sortBy.split(':::')[1],
        sortBy: state.sortBy.split(':::')[0],
        fromDate: state.startDate,
        toDate: state.endDate,
        ...getAppliedFilters(state.filterFields)
      },
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData
    }).then((res) => {
      commit(types.INTERACTIONS_LIST_NOT_LOADING)
      intData = {
        interactionsList: res.data.content,
        totalElements: res.data.totalElements,
        pageSize: 20,
        lastPage: res.data.last
      }
      commit(types.SET_INTERACTIONS_TRANSITION, 'all-list')
      commit(types.SET_INTERACTIONS_LOADED, intData)
      setTimeout(() => {
        commit(types.SET_INTERACTIONS_TRANSITION, 'list')
      }, 1000)
    }).catch((err) => {
      commit(types.INTERACTIONS_LIST_NOT_LOADING)
      console.log(':(' + err)
    })
  },
  [actionTypes.GET_INTERACTIONS_LIST] (context) {
    // flagEnableInteractions
    if (context.getters.HAS_FEATURE_FLAG(context.rootState.profile.module.interexem + '.' + context.rootState.profile.functions.headerMenu + '.' + context.rootState.profile.options.enable.interactions)) {
      const actionData = {action: actionTypes.GET_INTERACTIONS_LIST}
      store.dispatch(actionTypes.GET_TUTOR_BOOLEAN)
      if (context.state.loading || context.state.lastPage) {
        return Promise.resolve()
      }

      return new Promise((resolve, reject) => {
        context.commit(types.INTERACTIONS_LIST_LOADING)

        getInteractionsList(context, actionData)
          .then(result => {
            let data = {
              interactionsList: result.data.content,
              totalElements: result.data.totalElements,
              pageSize: result.data.totalElements,
              lastPage: result.data.last
            }
            context.commit(types.SET_INTERACTIONS_TRANSITION, 'all-list')
            context.commit(types.SET_INTERACTIONS_LOADED, data)
            setTimeout(() => {
              context.commit(types.SET_INTERACTIONS_TRANSITION, 'list')
            }, 1000)
            resolve(data)
          })
          .catch((err) => {
            console.error('Error fetching interactions', err)
            context.commit(types.INTERACTIONS_LIST_NOT_LOADING)
            reject(err)
          })
      })
    }
  },
  [actionTypes.LOGOUT] (context) {
    context.commit(types.RESET_INTERACTIONS_MODULE)
  },
  [actionTypes.GET_INTERACTIONS_LIST_START] (context) {
    context.commit(types.EMPTY_INTERACTIONS_LIST)
    context.commit(types.SET_INTERACTIONS_TRANSITION, 'all-list')
    return context.dispatch(actionTypes.GET_INTERACTIONS_LIST)
  },
  [actionTypes.CHANGE_INTERACTIONS_SORTING] (context, sortField) {
    context.commit(types.EMPTY_INTERACTIONS_LIST)
    context.commit(types.SET_INTERACTIONS_SORTING, sortField)
    context.commit(types.SET_INTERACTIONS_TRANSITION, 'all-list')
    return context.dispatch(actionTypes.GET_INTERACTIONS_LIST)
  },
  [actionTypes.CHANGE_INTERACTIONS_FILTER] ({state, commit, dispatch}, filterObject) {
    // Toggle interactions filter buttons
    commit(types.TOGGLE_INTERACTIONS_LIST_FILTER, filterObject)
    // check if my tutees filter button has been applied
    if (filterObject['filterType'] === 'myTutees') {
      // Toggle dashboard filter buttons
      commit(types.TOGGLE_DASHBOARD_FILTER, filterObject)
      // Toggle my students filter buttons
      commit(types.TOGGLE_STUDENTS_LIST_FILTER, filterObject)

      // Call endpoints for my students
      commit(types.SOFT_RESET_STUDENT_LIST)
      dispatch(actionTypes.GET_LIST_OF_STUDENTS)
    }
    // Call endpoints for interactions
    commit(types.EMPTY_INTERACTIONS_LIST)
    dispatch(actionTypes.GET_INTERACTIONS_LIST_START)
  },
  [actionTypes.CLEAR_INTERACTIONS_FILTERS] ({state, commit, dispatch}, filterObject) {
    // Clear all interaction filters
    commit(types.CLEAR_INTERACTIONS_LIST_FILTERS)
    // Clear all dashboard filters (since only filter is myTutees)
    commit(types.CLEAR_DASHBOARD_FILTERS)
    let isTutorFilterOn = state.filterFields.myTutees.values.MY_TUTEES.value
    if (isTutorFilterOn) {
      // Toggle 'myTutees' my students filter button (only)
      commit(types.TOGGLE_STUDENTS_LIST_FILTER, {filterType: 'myTutees', filterName: 'MY_TUTEES'})
    }

    // Re-call endpoints for my students
    commit(types.SOFT_RESET_STUDENT_LIST)
    dispatch(actionTypes.GET_LIST_OF_STUDENTS)
    // Re-call endpoints for interactions
    commit(types.EMPTY_INTERACTIONS_LIST)
    dispatch(actionTypes.GET_INTERACTIONS_LIST_START)
  },
  [actionTypes.UPDATE_INTERACTIONS_PAGE] (context) {
    // flagEnableInteractions
    if (context.getters.HAS_FEATURE_FLAG(context.rootState.profile.module.interexem + '.' + context.rootState.profile.functions.headerMenu + '.' + context.rootState.profile.options.enable.interactions)) {
      const pageNumber = context.state.currentPage
      const pageSize = context.state.pageSize
      context.commit(types.SET_INTERACTIONS_PAGE_NUMBER, 0)

      getInteractionsList(context)
        .then(res => {
          context.commit(types.REPLACE_INTERACTIONS, res.data.content)
          context.commit(types.SET_INTERACTIONS_TOTAL_ELEMENTS, res.data.totalElements)
          context.commit(types.SET_INTERACTIONS_PAGE_SIZE, pageSize)
          context.commit(types.SET_INTERACTIONS_PAGE_NUMBER, pageNumber)
        })
        .catch(err => {
          context.commit(types.SET_INTERACTIONS_PAGE_SIZE, pageSize)
          context.commit(types.SET_INTERACTIONS_PAGE_NUMBER, pageNumber)
          console.error(err)
        })
    }
  },
  [actionTypes.GET_INTERVENTION_INTERACTIONS] ({commit, dispatch, state}) {
    // set value before resetting
    let isTutorFilterOn = state.filterFields.myTutees.values.MY_TUTEES.value
    // Reset my students filters
    commit(types.RESET_INTERACTIONS_MODULE)
    if (isTutorFilterOn) {
      // re-toggle the 'myTutees' filter button
      commit(types.TOGGLE_INTERACTIONS_LIST_FILTER, {
        filterType: 'myTutees',
        filterName: 'MY_TUTEES'
      })
    }
    // toggle the 'INTERVENTION' filter button
    commit(types.TOGGLE_INTERACTIONS_LIST_FILTER, {
      filterName: 'INTERVENTION',
      filterType: 'interactionTypes'
    })
    // call interactions endpoint
    dispatch(actionTypes.GET_INTERACTIONS_LIST_START)
  },
  [actionTypes.GET_ALERT_INTERACTIONS] ({commit, dispatch, state}, dateObject) {
    // set value before resetting
    let isTutorFilterOn = state.filterFields.myTutees.values.MY_TUTEES.value
    // Reset my students filters
    commit(types.RESET_INTERACTIONS_MODULE)
    if (isTutorFilterOn) {
      // re-toggle the 'myTutees' filter button
      commit(types.TOGGLE_INTERACTIONS_LIST_FILTER, {
        filterType: 'myTutees',
        filterName: 'MY_TUTEES'
      })
    }
    commit(types.INTERACTIONS_DATE_FILTER_CHANGE, dateObject)
    // toggle the 'ALERT' filter button
    commit(types.TOGGLE_INTERACTIONS_LIST_FILTER, {
      filterName: 'ALERT',
      filterType: 'interactionTypes'
    })
    // call interactions endpoint
    dispatch(actionTypes.GET_INTERACTIONS_LIST_START)
  }
}

const getters = {
  GET_ALL_VISIBLE_INTERVENTIONS (state) {
    return state.interactionsList.filter(i => !i.isHidden)
  }
}

export default {
  state: defaultState(),
  mutations,
  actions,
  getters
}

export const changeInterventionVisibility = (obj, hidden) => {
  if (obj) {
    obj.isHidden = hidden
    obj.isOpen = false
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/interactionsModule.js